<section>
  <!-- <h4 style="margin-top: 20px;margin-bottom: 10px;"><i>Field type 1 ( CIRCLE )</i></h4> -->
<!-- <swiper-container class="swiper-container-circle" init="false" #swiperCircle>
  @for (field of fields; track field.position) {
    <swiper-slide>
        <div [class]="styleField(field.position)">
          <div class="info-field">
            <div class="block-icons" matTooltip="{{field.comment}}">
              @for (icon of field.icons; track $index) {
                <span class="material-symbols-outlined">
                  {{ icon }}
                </span>
              }
            </div>

            <span style="font-size: 0.9rem;">{{ field.title }}</span>
          </div>
          
          <div class="game-chip" [style.background-color]="field.sector_color">
            @if(this.players.playerOnField.length){
              @for(player of this.players.playerOnField;track player.position){
                @if(player.position === field.position){
                  <div class="user-fishka" matTooltip="{{player.userName}}">
                    <span class="material-symbols-outlined {{player.role_icon}}" ></span>
                  </div>
                }
              }
            }
          </div>
        </div>
    </swiper-slide>
  }
</swiper-container> -->


<div class="d-flex  justify-content-start align-items-center gap-1 mobile-content" style="width: fit-content;">
  @if(players.players.length === 1){
@for (field of fields; track field.position) { 
   @if(!field.isEmptyField){
    <div [class]="styleField(field.position, field.style)">
      <div class="info-field d-flex flex-column">
        <div class="block-icons d-flex justify-content-center align-items-center" matTooltip="{{field.comment}}" >
          @for (icon of field.icons; track $index) {
            <div class="block-icons__icon" [style.background-color]="addOpacity(field.sector_color)">
                <span class="material-symbols-outlined" [style.color]="field.sector_color">
                  {{ icon }}
                </span>
            </div>
          }
        </div>
        <span class="info-field__title">{{ field.title }}</span>
        <div class="line-all"></div>
        <span class="info-field__description">{{ field.comment }}</span>
        @if(allStatus$.maxPointresultCard > 0){
          <span class="info-field__xp">+{{ allStatus$.maxPointresultCard }} XP</span>
        }
      </div>

    </div>    
   }   

}
  }@else {
    <swiper-container class="swiper-container-circle" init="false" #swiperCircle>
  @for (field of fields; track field.position) {
        @if(field.style === 'show-field'){
          <swiper-slide>
          <div [class]="styleField(field.position, field.style)">
            <div class="info-field d-flex flex-column">
              <div class="block-icons d-flex justify-content-center align-items-center" matTooltip="{{field.comment}}" >
                @for (icon of field.icons; track $index) {
                  <div class="block-icons__icon" [style.background-color]="addOpacity(field.sector_color)">
                      <span class="material-symbols-outlined" [style.color]="field.sector_color">
                        {{ icon }}
                      </span>
                  </div>
                }
              </div>
              <span class="info-field__title">{{ field.title }}</span>
              <div class="line-all"></div>
              <span class="info-field__description">{{ field.comment }}</span>
              @if(allStatus$.maxPointresultCard > 0){
                <span class="info-field__xp">+{{ allStatus$.maxPointresultCard }} XP</span>
              }
            </div>

          </div>
          </swiper-slide>    
        }   
    
  }
</swiper-container>
  }

</div>

</section>
